import React from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../../layouts/dashboard_header";
import SideMenu from "../../layouts/dashboard_menu";
import DashboardFooter from "../../layouts/dashboard_footer";
import Canvas from "../../layouts/dahboard_canvas";

interface TelehealthShellProps {
    title: string;
    description: string;
    activeTab: "overview" | "history" | "devices" | "messaging";
    action?: React.ReactNode;
    children: React.ReactNode;
}

const tabs = [
    { key: "overview", label: "Overview", path: "/institution/telehealth", icon: "bx bx-video" },
    { key: "history", label: "History", path: "/institution/telehealth/history", icon: "bx bx-history" },
    { key: "devices", label: "Devices", path: "/institution/telehealth/devices", icon: "bx bx-chip" },
    { key: "messaging", label: "Coordination", path: "/institution/telehealth/messaging", icon: "bx bx-message-rounded-detail" },
] as const;

const TelehealthShell: React.FC<TelehealthShellProps> = ({ title, description, activeTab, action, children }) => {
    return (
        <>
            <DashboardHeader />
            <SideMenu />
            <div className="main-content">
                <div className="page-content">
                    <div className="sc-wrap">
                        <div className="sc-header">
                            <div>
                                <h1>{title}</h1>
                                <p>{description}</p>
                            </div>
                            {action}
                        </div>
                        <div className="sc-tabs">
                            {tabs.map((tab) => (
                                <Link key={tab.key} to={tab.path} className={`sc-tab ${activeTab === tab.key ? "active" : ""}`}>
                                    <i className={tab.icon}></i>
                                    {tab.label}
                                </Link>
                            ))}
                        </div>
                        {children}
                    </div>
                </div>
                <DashboardFooter />
            </div>
            <Canvas />
        </>
    );
};

export default TelehealthShell;
